// removed by extract-text-webpack-plugin
module.exports = {"block":"_22p4w8tYUeNpqwkrikPKdS","list":"_b1eLvwbyLan2brP3wyAZ","scroll-button":"_2c2sehz-rHjPq-tbHxbDAr","adaptiveHeightContainer":"_1kpzXTzIlp-HErQ9p1U5Tp","indicators":"_3g3XPxDNqOOCk5EyjZxwOt","indicator":"_2H39Q8dM2FUaCHwpaPaGhr","active":"_2iOsY92ndSEmWVMq6qYpCo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullscreenListBlock/FullscreenListBlock.module.scss
// module id = 767
// module chunks = 0